<template>
  <!-- Główny kontener filtrów dla bieżących pomiarów pojazdów -->
  <div class="filters-container">
    <!-- Legenda ikon/statusów dla użytkownika — tylko w kroku 1 (wybór lokalizacji) -->
    <legend-list v-if="current.step === 1" />

    <!-- Filtr lokalizacji (np. wybór stacji preselekcji) -->
    <locations-filter-view :store="filtersStore" />

    <!-- Filtr kategorii pojazdów (np. ciężarowe, osobowe) -->
    <vehicle-categories-filter-view :store="filtersStore" />

    <!-- Filtr naruszeń/przekroczeń (np. przeciążenie, prędkość) -->
    <violation-filter-view :store="filtersStore" />

    <!-- Filtr numerów pasów (jezdni, np. pas 1, 2) -->
    <lane-numbers-filter-view :store="filtersStore" />

    <!-- Dodatkowy filtr na parametry pojazdu (np. długość, masa, inne dane techniczne) -->
    <vehicle-data-filter-view />
  </div>
</template>

<script>
// Import Pinia store do zarządzania aktualnymi filtrami pomiarów
import { useCurrentFiltersStore } from "@/stores/currentFilters";
// Store z aktualnym krokiem kreatora (do warunkowego pokazania legendy)
import { useCurrentStore } from "@/stores/current";
// Import poszczególnych komponentów filtrujących
import LocationsFilterView from "./filters/LocationsFilterView.vue";
import VehicleCategoriesFilterView from "./filters/VehicleCategoriesFilterView.vue";
import LaneNumbersFilterView from "./filters/LaneNumbersFilterView.vue";
import ViolationFilterView from "./filters/ViolationFilterView.vue";
import LegendList from "./filters/LegendList.vue";
import VehicleDataFilterView from "./current/VehicleDataFilterView.vue";

export default {
  // Rejestracja child components
  components: {
    LocationsFilterView,
    VehicleCategoriesFilterView,
    LaneNumbersFilterView,
    ViolationFilterView,
    LegendList,
    VehicleDataFilterView,
  },
  name: "FilterCurrentMeasurement",
  setup() {
    // Inicjalizujemy store Pinia dla filtrów bieżących
    const filtersStore = useCurrentFiltersStore();
    // Store z bieżącym krokiem (legendę pokazujemy tylko w kroku 1)
    const current = useCurrentStore();
    // Udostępniamy je w template
    return { filtersStore, current };
  },
};
</script>

<style scoped>
/* Ustawienia szerokości i tła panelu filtrów */
.filters-container {
  width: 365px;
  background: url("../assets/l-filter-bg.png") repeat-y right;
}
</style>
